var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","right":"10px","bottom":"10px","z-index":"1000"}},_vm._l((_vm.themeColors),function(c){return _c('div',{key:c,staticClass:"l-color-box"},[_c('div',{style:(`width:15px;height:15px;margin-right:10px;flex-shrink:0;border-radius:50%;background:var(--${c})`)}),_vm._v(" "+_vm._s(c)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }